import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { UpdateCartProduct } from './UpdateCartProduct'
/**
* Class UpdateCart
*  Данные для изменения корзины
*/
export class UpdateCart extends ActiveModel {

/**
  * @property products
  * Данные для изменения продуктов корзины<br>  */
  @ActiveField({
    factory: [UpdateCartProduct, () => undefined]
  })
  products?: Array<UpdateCartProduct>
}
